import React,{ useState, useEffect, useRef } from 'react';
import { Col, Row } from 'antd';

import CardDom from '../CardDom/CardDom';

import './ImgTimeLine.less';

const ImgTimeLine = ({ImgTimeLineData}) =>{
  const [selectData, setSelectData] = useState(0)

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  const handleTouchStart = (ev) => {
    setIsDragging(true);
    setStartX(ev.touches[0].clientX);
  };
 
  const handleTouchMove = (ev) => {
    if (!isDragging) return;
    const currentX = ev.touches[0].clientX;
    const diffX = currentX - startX;
    console.log(diffX)
    // 根据滑动距离来决定是否切换图片
    if (diffX > 50) {
      setSelectData((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : ImgTimeLineData.data.length - 1));
      setIsDragging(false);
    } else if (diffX < -50) {
      setSelectData((prevIndex) => (prevIndex < ImgTimeLineData.data.length - 1 ? prevIndex + 1 : 0));
      setIsDragging(false);
    }
  };
 
  const handleTouchEnd = () => {
    setIsDragging(false);
    // 在这里可以添加滑动结束后的逻辑，例如计算滑动的距离或速度等
  };
  if(width > 770){
    return (
      <div>
        <div className="introduction-text-box">
          <div style={{width:'50%'}}>
            <p>{ImgTimeLineData.title}</p>
            <p>{ImgTimeLineData.subTitle}</p>
          </div>
        </div>
        <div className='ImgTimeLineList-box' style={{position: 'relative', marginBottom: 250}}>
          <div className="ImgTimeLineList">
            {ImgTimeLineData.data.map((e,i)=>{
              return (
                <div 
                  key={i} 
                  className="ImgTimeLineList-item" 
                  style={selectData === i? {width:'25%', alignSelf: 'end'}:{alignSelf: 'end'}} 
                  onClick={()=> setSelectData(i)}
                >
                  <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  
                  <div className="ImgTimeLineList-detail-item" style={selectData === i? {display:'block'}:{display:'none'}}>
                    <div>{e.content.subTitle}</div>
                    <div style={{color:'rgba(0,0,0,0.54)'}}>{e.content.description}</div>
                  </div>
                  
                </div>
              )
            })}
          </div>
          <div className="ImgTimeLineList copyDom" aria-hidden="true">
            {ImgTimeLineData.data.map((e,i)=>{
              return (
                <div 
                  key={i} 
                  className="ImgTimeLineList-item" 
                  style={i===0? {width:'25%', alignSelf: 'end'}:{alignSelf: 'end'}} 
                >
                  <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  
                  <div className="ImgTimeLineList-detail-item" style={i===0? {display:'block'}:{display:'none'}}>
                    <div>{e.content.subTitle}</div>
                    <div style={{color:'rgba(0,0,0,0.54)'}}>{e.content.description}</div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }else{
   
    return (
      <div>
        <div className="introduction-text-box" style={{padding: '0 25px'}}>
          <div style={{width:'100%'}}>
            <p>{ImgTimeLineData.title}</p>
            <p>{ImgTimeLineData.subTitle}</p>
          </div>
        </div>
        
        <div style={{padding: '0 25px'}}>
          <Row gutter={16}>
            {ImgTimeLineData.data.map((e,i)=>{
              return (
                <Col key={i} className="gutter-row" span={24/ImgTimeLineData.data.length} onClick={()=> setSelectData(i)}>
                  <div style={selectData === i? {borderTop: '1px solid #000'}:{borderTop: '1px solid rgba(0,0,0,0.12)'}}>
                    {e.content.title}
                  </div>
                </Col>
              )
            })}
          </Row>
        </div>
        
        <div className='ImgTimeLineList-box-phone' style={{position: 'relative', marginBottom: 250}}>
          <div 
            className="ImgTimeLineList"
            style={{left: 15-selectData*(width*0.7)}}
            onTouchStart={(ev)=> handleTouchStart(ev)}
            onTouchMove={(ev)=> handleTouchMove(ev)}
            onTouchEnd={(ev)=> handleTouchEnd(ev)}
          >
            {ImgTimeLineData.data.map((e,i)=>{
              return (
                <div 
                  key={i} 
                  className="ImgTimeLineList-item" 
                  style={{alignSelf: 'end'}} 
                  onClick={()=> setSelectData(i)}
                >
                  <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  
                  <div className="ImgTimeLineList-detail-item">
                    <div>{e.content.subTitle}</div>
                    <div style={{color:'rgba(0,0,0,0.54)'}}>{e.content.description}</div>
                  </div>
                  
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default ImgTimeLine